// Bump this whenever the SMS consent disclosure wording changes.
// It's persisted alongside every opt-in so we can audit exactly which
// version of the language the user agreed to.
export const SMS_CONSENT_VERSION = "2026-02-2";
